import { createTheme } from '@mui/material';
export const breakpoints = {
    values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
    },
};
// extract breakpoint methods for easier use
export const breakpointsMethods = createTheme({ breakpoints }).breakpoints;
